import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import './plugins/axios.js'
import Vant, {Lazyload} from 'vant';
import 'vant/lib/index.css';
import VueMeta from "vue-meta";

Vue.use(VueMeta, {
    // optional pluginOptions
    refreshOnceOnNavigation: true
})

Vue.config.productionTip = false
Vue.use(Vant)
// 注册时可以配置额外的选项
Vue.use(Lazyload, {
    lazyComponent: true,
});
new Vue({
    store,
    router,
    render: h => h(App)
}).$mount('#app')
